module.exports = __webpack_public_path__ + "img/page_31.aae848ea.png";